import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {AppState} from '../../../store/appState';
import {getFlatCrmSyncs} from '../../../store/data/crmSync/crmSyncSelectors';
import {updateSelectedCrmPreviewAction} from '../../../store/panels/contacts/contactsManager/crmPreview/crmPreviewActions';
import {makeGetCrmPreviewPanel} from '../../../store/panels/contacts/contactsManager/crmPreview/crmPreviewSelectors';
import {CrmPreviewPanelId} from '../../../store/panels/panelStateBase';
import {CrmPreview} from './crmPreview';

/*
 * Types.
 */

interface CrmPreviewContainerProps {
  panelId: CrmPreviewPanelId;
  crmSyncId: number;
}

/*
 * Selectors.
 */

function getCrmSyncId(_state: AppState, props: CrmPreviewContainerProps) {
  return props.crmSyncId;
}

function makeGetCrmSync() {
  return createSelector([getCrmSyncId, getFlatCrmSyncs], (crmSyncId, crmSyncs) =>
    crmSyncs.find((crmSync) => crmSync.id === crmSyncId),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CrmPreviewContainerProps>()(() => ({
  crmSync: makeGetCrmSync(),
  panelState: makeGetCrmPreviewPanel(),
}));

const mapDispatchToProps = makeMapDispatchToProps<CrmPreviewContainerProps>()(({panelId}) => ({
  updateSelectedId: (selectedId: number) => updateSelectedCrmPreviewAction(panelId, selectedId),
}));

export const CrmPreviewContainer = connect(mapStateToProps, mapDispatchToProps)(CrmPreview);
